// extracted by mini-css-extract-plugin
export default {"content":"SectionLayout_content__jWdIH","section":"SectionLayout_section__6ZEah","show":"SectionLayout_show__CWoao","separator":"SectionLayout_separator__0vEsG"};